import React, { useState } from 'react'
import QuestionStats from '../components/quiz/QuestionStats'

const QuestionStatsTest: React.FC = () => {
  const [testParams, setTestParams] = useState({
    lop: '11',
    chuong: '1',
    bai: '1'
  })

  const availableTests = [
    { lop: '11', chuong: '1', bai: '1', name: 'Lớp 11 - Chương 1 - Bài 1' },
    { lop: '11', chuong: '1', bai: '4', name: 'Lớp 11 - Chương 1 - Bài 4' },
    { lop: '11', chuong: '2', bai: '7', name: 'Lớp 11 - Chương 2 - Bài 7' },
    { lop: '11', chuong: '4', bai: '15', name: 'Lớp 11 - Chương 4 - Bài 15' },
  ]

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-3xl font-bold text-center mb-8">
          Test Thống Kê Câu Hỏi
        </h1>

        {/* Test Controls */}
        <div className="bg-white rounded-xl p-6 mb-8 shadow-sm">
          <h2 className="text-xl font-semibold mb-4">Chọn bài học để test</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            {availableTests.map((test, index) => (
              <button
                key={index}
                onClick={() => setTestParams(test)}
                className={`p-4 rounded-lg border-2 text-left transition-colors ${
                  testParams.lop === test.lop && 
                  testParams.chuong === test.chuong && 
                  testParams.bai === test.bai
                    ? 'border-blue-500 bg-blue-50 text-blue-700'
                    : 'border-gray-200 hover:border-gray-300'
                }`}
              >
                <div className="font-medium">{test.name}</div>
                <div className="text-sm text-gray-500">
                  L{test.lop}_C{test.chuong}_B{test.bai}
                </div>
              </button>
            ))}
          </div>

          {/* Manual Input */}
          <div className="border-t pt-4">
            <h3 className="font-medium mb-3">Hoặc nhập thủ công:</h3>
            <div className="grid grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Lớp
                </label>
                <input
                  type="text"
                  value={testParams.lop}
                  onChange={(e) => setTestParams(prev => ({ ...prev, lop: e.target.value }))}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="10, 11, 12"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Chương
                </label>
                <input
                  type="text"
                  value={testParams.chuong}
                  onChange={(e) => setTestParams(prev => ({ ...prev, chuong: e.target.value }))}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="1, 2, 3..."
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Bài
                </label>
                <input
                  type="text"
                  value={testParams.bai}
                  onChange={(e) => setTestParams(prev => ({ ...prev, bai: e.target.value }))}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="1, 2, 3..."
                />
              </div>
            </div>
          </div>
        </div>

        {/* Question Stats Display */}
        <div className="max-w-md mx-auto">
          <QuestionStats
            lop={testParams.lop}
            chuong={testParams.chuong}
            bai={testParams.bai}
          />
        </div>

        {/* Navigation */}
        <div className="text-center mt-8">
          <a
            href="/"
            className="inline-flex items-center px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
          >
            ← Về trang chủ
          </a>
        </div>
      </div>
    </div>
  )
}

export default QuestionStatsTest